module.exports = __webpack_public_path__ + "static/media/student-form-mail-icon.2869f876.svg";